const STORAGE_KEY = 'easya:pending-redirect'

/**
 * Адрес, на который вернуть пользователя после входа.
 *
 * Нужен экрану согласия на подключение AI-агента: сценарий начинается вне SPA,
 * клиент присылает пользователя с параметрами OAuth в query, и если тот не
 * авторизован, потерять эти параметры нельзя — подключение придётся начинать
 * заново из самого агента.
 *
 * Только внутренние пути: адрес приходит из query-строки, и открытый редирект
 * на чужой домен после логина был бы дырой для фишинга.
 */
export function rememberPendingRedirect(path: string): void {
  if (!isInternalPath(path)) {
    return
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, path)
  } catch {
    // Приватный режим или запрещённое хранилище: возврат просто не сработает.
  }
}

/** Забрать сохранённый адрес и сразу очистить его — он одноразовый. */
export function takePendingRedirect(): string | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY)
    sessionStorage.removeItem(STORAGE_KEY)

    return value !== null && isInternalPath(value) ? value : null
  } catch {
    return null
  }
}

/** Путь внутри приложения: начинается с одного слэша и без схемы. */
function isInternalPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//')
}
